const USER_ROLES = {
    ADMINISTRATOR: "administrator",
    MANAGER: "manager",
    EMPLOYEE: "employee",
    PROJECT_MANAGER: "project_manager",
    PRODUCER: "producer",
    OFF_SHORE_LEAD: "off_shore_lead",
    LEADERSHIP: "leadership",
    LOB_ADMIN: "lobadmin"
  };
  
  module.exports ={
      USER_ROLES
  }